/**
 * 数据存储模块
 * key -> value
 */
import {
  getErrorFactory,
  supportNative,
  logError
} from './util';

const zzc = window.zzc;
const NAMESPACE = 'trip';
const localStorage = window.localStorage;


function supportNativeStorage() {
  // return false;
  return supportNative('base_localStorageGetItem')
    && supportNative('base_localStorageSetItem');
}

function getLocalStorageKey(key) {
  return NAMESPACE + '-' + key;
}




/**
 * 从数据库获取数据
 * 如果value是`json string`，会被解析为`json object`
 *
 * @export
 * @param {string} key
 * @returns Promise.resolve(value)
 */
export function getItem(key) {
  return new Promise(function (resolve, reject) {
    // let errorFactory = getErrorFactory('storage.getItem');

    if (supportNativeStorage()) {
      zzc.call('base_localStorageGetItem', {
        key: key,
        namespace: NAMESPACE,
        complete: function (res) {
          // 这个接口不遵守res规范
          resolve(JSON.parse(res.data));
        }
      });
    } else {
      key = getLocalStorageKey(key);
      let value = localStorage.getItem(key);
      try {
        value = JSON.parse(value);
      } catch (err) {}
      console.log(value);

      resolve(value);
    }
  });
}


/**
 * 向数据库存储数据
 * 如果value不是`string`会被`JSON.stringify()`序列化
 *
 * @export
 * @param {any} key
 * @param {any} value
 * @returns Promise.resolve(value)
 */
export function setItem(key, value) {
  return new Promise(function (resolve, reject) {
    let errorFactory = getErrorFactory('storage.setItem');

    if (typeof value !== 'string') {
      try {
        value = JSON.stringify(value);
      } catch (err) {
        let error = errorFactory('value是无法序列号的object对象：' + err.message);
        logError(error);
        return reject(error);
      }
    }

    if (supportNativeStorage()) {
      zzc.call('base_localStorageSetItem', {
        key: key,
        value: value,
        namespace: NAMESPACE,
        complete: function (res) {
          if (res.state) {
            let err = errorFactory(res.message);
            logError(err);
            return reject(err);
          } else {
            // 并不需要res
            resolve(true);
          }
        }
      });
    } else {
      key = getLocalStorageKey(key);
      localStorage.setItem(key, value);
      resolve(true);
    }
  });
}


/**
 * 删除数据
 * @param {*} key
 */
export function removeItem(key) {
  return new Promise(function (resolve, reject) {
    let errorFactory = getErrorFactory('storage.removeItem');

    if (supportNativeStorage()) {
      zzc.call('base_localStorageRemoveItem', {
        key: key,
        namespace: NAMESPACE,
        complete: function (res) {
          if (res.state) {
            let err = errorFactory(res.message);
            logError(err);
            return reject(err);
          } else {
            // 并不需要res
            resolve(true);
          }
        }
      });
    } else {
      key = getLocalStorageKey(key);
      localStorage.removeItem(key);
      resolve(true);
    }
  });
}



// WEBPACK FOOTER //
// ./src/native/storage.js